module.exports = __webpack_public_path__ + "static/img/introduce_platform.848c9fd2.png";